export default __webpack_public_path__ + "static/media/fiat.2756e119.png";